import { makeNumberSchema, makeStrictNumberSchema } from '../general/number.ts';

const MIN = 1;
const MAX = Number.MAX_SAFE_INTEGER; /* different from api max b/c JS can't represent it w/ number */

const minMessage = `Write buffer must be at least ${MIN.toLocaleString()}`;
const maxMessage = `Write buffer can be at most ${MAX.toLocaleString()}`;
const requiredMessage = `Choose a number from ${MIN.toLocaleString()} to ${MAX.toLocaleString()}`;

export const listenWriteBufferSchema = makeNumberSchema({
  min: { value: MIN, message: minMessage },
  max: { value: MAX, message: maxMessage },
});

export const listenWriteBufferRequiredSchema = listenWriteBufferSchema.refine((val): val is number => val !== null, {
  message: requiredMessage,
});

export const listenWriteBufferStrictSchema = makeStrictNumberSchema({
  min: { value: MIN, message: minMessage },
  max: { value: MAX, message: maxMessage },
  required: { message: requiredMessage },
});
